<template>
    <admin-header />
    <div class="bg-leftPanelBG fixed inset-0 top-16"></div>
    <div class="rounded-lg w-full min-h-lg max-w-md mx-auto my-auto p-8 sm:p-12 z-50 overflow-auto relative bg-white mt-20">
        <div>
            <h2 class="font-black text-xl mb-8 leading-none">Sign in</h2>
            <form @submit.prevent="">
                <div class="relative">
                    <div class="mt-7">
                        <label for="email" v-if="!formData.email" class="cursor-text text-gray-700 absolute ml-2">Email address*</label>
                        <input type="email" id="email" v-model="formData.email" autocomplete="email" class="w-full font-regular z-10 cursor-text border-0 shadow-none rounded-none border-b border-sepBorder focus:outline-none focus:border-blue-500 transition duration-300 ease-in-out px-2 py-1 text-gray-700">
                    </div>
                    <div class="mt-6">
                        <label for="password" v-if="!formData.password" class="cursor-text text-gray-700 font-normal absolute ml-2">Password*</label>
                        <input type="password" id="password" v-model="formData.password" autocomplete="current-password" class="w-full cursor-text z-10 border-0 shadow-none rounded-none border-b border-sepBorder focus:outline-none focus:border-blue-500 transition duration-300 ease-in-out px-2 py-1 text-gray-700">
                    </div>
                </div>
                <div v-if="error" class="mt-4 text-red-400 text-sm">{{error}}</div>
                <button @click="login" type="submit" class="mt-4 transition ease-in-out bg-growth rounded-xl p-2 px-6 text-white font-semibold shadow hover:shadow-light dark:shadow-dark hover:scale-105"> 
                    <font-awesome-icon v-if="loading" icon="fa-spinner" class="animate-spin mr-3" />
                    Log in
                </button>
            </form>
        </div>
    </div>
</template>
  
<script setup>
    import adminHeader from '@/components/admin/AdminHeader.vue';
</script>

<script>
    import { admin_login } from '@/api/admin_api';
    export default {
        name: 'Login',
        data() {
        return {
            formData: {
                email: null,
                password: null
            },
            error: null,
            loading: false
        };
        },
        methods: {
            async login() {
                this.loading = true;

                if (this.formData?.email && this.formData?.password) {
                    const loginResponse = await admin_login(this.formData.email, this.formData.password);
                    if (loginResponse.success == true && loginResponse?.data?.admin_auth_token) {
                        // Set the admin_auth_token cookie on successful login
                        this.$cookies.set('admin_auth_token', loginResponse?.data?.admin_auth_token, { expires: 3 }); // expires in 3 days
                        this.$router.push('/admin'); // Redirect to admin dashboard
                    } else {
                        this.error = 'Invalid email or password';    
                    }
                } else {
                    this.error = 'Invalid email or password';
                }
                setTimeout(() => {
                    this.loading = false;
                }, 1000);
            }
        }
    };
</script>  